export default "__VITE_ASSET__4MbjvatX__"